<template>
	<div class="operation-reduce-fractions-same-denominator-component">
		<div class="reduce-same-denominator">
			<div class="fractions">
				<div class="fraction" v-for="(fraction, i) in fractions" :key="`fraction-${i + 1}`">
					<fraction :fraction="fraction" />
					<template v-if="!fraction.isSimplificated">
						<span class="equal-sign">=</span>
						<fraction :fraction="fraction.simplification" />
						<!-- 
						<FractionComponent :fraction="simplificated(fraction).reduction_to(ppcm)" />
						<span class="equal-sign">=</span>
						<fractionComponent :fraction="fraction.simplificated" /> -->
					</template>
					<span class="equal-sign">=</span>
					<fraction :fraction="fraction.get_reduced(ppcm)" class="result" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Fraction from '../scripts/Fraction';
	import FractionComponent from '../FractionComponent.vue';
	import UFCT from 'usefull-functions';

	export default{
		name: "ReduceToSameDenominator",
		components: { Fraction: FractionComponent },
		props:{
			terms: { type: [Array], required: true }
		},
		data() {
			return {
				ppcm: null,
				fractions: this.terms.map(el => new Fraction(el))
			};
		},
		created() {
			// this.fractions = this.terms.map(el => new Fraction(el));
			this.ppcm = UFCT.ppcm(...this.fractions.map(el => el.simplificated.den));
		},
		methods:{
			simplificated(fract){
				return Number(fract.simplificated) ? fract : fract.simplificated;
			}
		}
	};
</script>